module.exports = __webpack_public_path__ + "static/045.thumb-2c7f10156273c45ccce532a048677f01.jpg";